var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.labelSize),function(size,i){return _c('b-dropdown-item',{key:i,attrs:{"href":_vm.setTypeUrlLabel( size.value, false ),"target":"_blank"}},[_vm._v("\n        "+_vm._s(size.text)+"\n    ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }